import React from 'react';
import {Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';

export const getSprintRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = sprint =>
		getGroupedRowColumns(
			{
				label: <span>{sprint.noSprint ? intl.formatMessage({id: 'time_reg_report.no_sprint'}) : sprint.name}</span>,
				actualHours: Util.convertMinutesToFullHour(sprint.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(sprint.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(sprint.timeRegTotals?.totalNonBillableRegistered, intl, true),
				actualBillableValueOfService: getCurrencyCell(sprint.timeRegTotals?.totalPrice, currency, intl),
				actualCost: getCurrencyCell(sprint.timeRegTotals?.totalCost, currency, intl),
			},
			customFieldDefinitions
		);

	return (
		<Table.Rows data={data} canExpand={true} loadMore={hasNextPage && fetchMore} {...nextLevelProps}>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noSprint === true ? GLOBAL_FILTER_FIELD.NON_SPRINT_TIME_REG : GLOBAL_FILTER_FIELD.SPRINT_TIME_REG;
				return (
					<>
						<Table.Row {...tableColumnsProps}>{getColumns(rowData)}</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.sprintId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
